import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetAuthCities, GetAuthCitiesModel, GetAuthCitiesParams} from 'domain/usecases';

export class RemoteGetAuthCities implements GetAuthCities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthCitiesModel>,
	) {}

	async get({signal, ...params}: GetAuthCitiesParams): Promise<GetAuthCitiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
